export default __webpack_public_path__ + "static/media/c2.85fda49f.jpg";